import { specificationsStyles as styles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsSpecifications";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.specificationsAccordion = {
    headingLevel: 5,
    css: css`
        dt[data-test-selector="sectionHeader"]:has(button[aria-expanded="false"]),
        dt[data-test-selector="sectionHeader"]:has(button[aria-expanded="true"]) + dd {
            margin-bottom: 16px;
        }

        dt[data-test-selector="sectionHeader"] button {
            border-top: 1px solid ${getColor(colorStrings.commonGlobalBlack)};
        }
    `,
};

styles.attributeTypeWrapper = {
    ...styles.attributeTypeWrapper,
    css: css`
        padding-bottom: 5px;
        margin-bottom: 5px;
        border-bottom: 1px solid ${getColor(colorStrings.commonBorder)};

        &:last-child {
            border-bottom: none;
            margin-bottom: 0;
            padding-bottom: 0;
        }
    `,
};

styles.attributeTypeLabelText = {
    ...styles.attributeTypeLabelText,
    css: css`
        width: 50%;
        display: inline-block;
        vertical-align: top;
    `,
};

styles.attributeTypeValuesText = {
    ...styles.attributeTypeValuesText,
    css: css`
        width: 50%;
        display: inline-block;
    `,
};

styles.documentsContainer = {
    ...styles.documentsContainer,
    gap: 5,
};

styles.documentGridItem = {
    ...styles.documentGridItem,
    width: 12,
};
